// src/utils/selectionUtils.js

export function activeModifierLevels(modifierLevels) {
  return Object.fromEntries(
    Object.entries(modifierLevels)
      .filter(([_, level]) => parseInt(level) !== 0)
      .map(([k, v]) => [k, parseInt(v)])
  );
}

export function buildPlaceholder({ voices, roles, formats, selectedVoice, selectedRole, selectedFormat, selectedAudiences, modifierLevels }) {
  const parts = [];
  if (selectedVoice) parts.push(voices.find(v => v.id === selectedVoice)?.name);
  if (selectedRole) parts.push(roles.find(r => r.id === selectedRole)?.name);
  if (selectedFormat) parts.push(formats.find(f => f.id === selectedFormat)?.name);
  if (selectedAudiences?.length) parts.push(`${selectedAudiences.length} audience${selectedAudiences.length > 1 ? 's' : ''}`);
  const modCount = Object.values(modifierLevels).filter(v => parseInt(v) !== 0).length;
  if (modCount) parts.push(`${modCount} adjustments`);
  const context = parts.filter(Boolean).slice(0, 2).join(', ');
  return context ? `Transform message (${context})...` : 'Type your message here...';
}

export function notifyError(scope, err, toast) {
  const msg = err?.message || String(err);
  console.error(`Error in ${scope}:`, err);
  toast?.error?.(`Failed: ${msg}`);
}
